// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1RHm0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayFreqTrend/styles.scss
// module id = 2263
// module chunks = 1